import { use, useEffect, useId } from 'react';

import type { ActionBarAction } from './actionBarAction';
import { ActionBarContext } from './actionBarContext';

export const useActionBarContext = () => {
	const context = use(ActionBarContext);
	if (!context) {
		throw new Error('useActionBarContext must be used within an ActionBarProvider');
	}

	return context;
};

interface ContributionOptions {
	priority?: number;
	id?: string;
	overflowLimit?: number;
}

export const useActionBarContribution = (
	actions: ActionBarAction[],
	{ priority = 0, id, overflowLimit }: ContributionOptions = {}
) => {
	const generatedId = useId();
	const sourceId = id ?? generatedId;

	const { registerActions, unregisterActions } = useActionBarContext();

	useEffect(() => {
		registerActions(sourceId, actions, { priority, overflowLimit });
		return () => {
			unregisterActions(sourceId);
		};
	}, [actions, overflowLimit, priority, registerActions, sourceId, unregisterActions]);
};
